import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ReactNode } from 'react';
import { StoneXLabeledItem } from '..';

interface StoneXToggleButtonProps {
  label?: ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
  trueLabel?: string;
  falseLabel?: string;
  disabled?: boolean;
}

export function StoneXToggleButton(props: StoneXToggleButtonProps) {
  const { label, value, onChange, trueLabel = 'Yes', falseLabel = 'No', disabled = false } = props;

  function handleChange(_event: React.MouseEvent<HTMLElement>, newValue: boolean | null) {
    if (newValue !== null) {
      onChange(newValue);
    }
  }

  return (
    <StoneXLabeledItem label={label}>
      <ToggleButtonGroup exclusive value={value} onChange={handleChange} disabled={disabled} sx={{ width: 100 }}>
        <ToggleButton value={true} sx={{ flex: 1 }}>{trueLabel}</ToggleButton>
        <ToggleButton value={false} sx={{ flex: 1 }}>{falseLabel}</ToggleButton>
      </ToggleButtonGroup>
    </StoneXLabeledItem>
  );
}